import React from 'react'

import Layout from '../layouts/en'
import Home from '../components/Home'

const IndexPage = () => (
  <Layout>
    <Home />
  </Layout>
)

export default IndexPage
